
























































import { Product } from '@/model/product';
import { ProductDisplayMode } from '@/model/product-display-mode';
import { ProductItemState } from '@/model/product-item-state';
import { ProductCollection } from '@/service/product';
import { VueLoaderService } from '@/util/loader';
import { Util } from '@/util/util';
import Vue from 'vue';
import { ProductPriceStock } from '@/model/product-price-stock';
import { ActionCollection } from '@/service/action-collection';
import { Action } from '@/model/action';
import { DiscountQuantityCollection } from '@/service/discount-quantity-collection';

interface VM  {
  product: Product | null,
  pps: ProductPriceStock | null, actions: Action[],
  quantityDiscounts: Action[],
  visibleProductActions: string[]
}

export default Vue.extend({
  name: 'ProductItem',
  components: {
    'product-row': VueLoaderService.lazyLoadComponent(import('./row/ProductRow.vue')),
    'product-action-row': VueLoaderService.lazyLoadComponent(import('./row/ProductActionRow.vue')),
    'product-list': VueLoaderService.lazyLoadComponent(import('./list/ProductList.vue')),
    'product-card': VueLoaderService.lazyLoadComponent(import('./card/ProductCard.vue')),
    'product-card-compact': VueLoaderService.lazyLoadComponent(import('./card/ProductCardCompact.vue'))
  },
  props: {
    productKey: {
      type: String,
      required: true
    },
    position: {
      type: Number,
      default: 0
    },
    location: {
      type: String,
      default: ''
    },
    columns: {
      type: Array as () => Array<string>,
      default: () => []
    },
    displayMode: {
      type: String,
      required: true,
      validator: ProductDisplayMode.isValidDisplayMode
    },
    actionCollection: {
      type: Object as () => ActionCollection,
      required: false,
      default: () => new ActionCollection()
    },
    quantityDiscountCollection: {
      type: Object as () => DiscountQuantityCollection,
      required: false,
      default: () => new DiscountQuantityCollection()
    },
    totalActiveColumns: {
      type: Number,
      default: -1 // Not specified
    },
    showGrossPrice: {
      type: Boolean,
      default: false
    },
    v2Styling: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    productKey() {
      this.refresh();
    },
    pps() {
      // reload actions and quantity discounts upon every PPS change
      this.actions = [];
      this.quantityDiscounts = [];

      if (this.pps == null) return;

      // reload actions
      if (this.pps.actions && this.pps.actions.length > 0) {
        this.pps.actions.forEach(id => {
          this.actionCollection.get(id).then(action => this.actions.push(action));
          this.$forceUpdate();
        });
      }

      // reload quantity discounts
      if (this.pps.quantityDiscounts && this.pps.quantityDiscounts.length > 0) {
        this.pps.quantityDiscounts.forEach(id => {
          this.quantityDiscountCollection.get(id).then(action => this.quantityDiscounts.push(action));
          this.$forceUpdate();
        });
      }
    }
  },
  data(): VM {
    return {
      product: null,
      pps: null,
      actions: [],
      quantityDiscounts: [],
      visibleProductActions: []
    };
  },
  mounted() {
    this.refresh();
  },
  computed: {
    displayState(): string {
      if (Util.isLoggedIn() == false) return ProductItemState.NOT_LOGGED_IN;

      if (this.product == null || this.pps == null) return ProductItemState.LOGGED_IN_NOT_LOADED;

      if (this.product.isOrderable(this.pps.totalStock, this.pps.itemBaseNetPrice, this.pps.priceOnRequest))
        return ProductItemState.LOGGED_IN_LOADED_ORDER_ABLE;
      else if (this.product.showPriceOnly(this.pps.totalStock, this.pps.itemBaseNetPrice, this.pps.priceOnRequest))
        return ProductItemState.LOGGED_IN_NOT_ORDERABLE_SHOW_PRICE_ONLY;

      return ProductItemState.LOGGED_IN_LOADED_NO_ORDER_ABLE;
    },

    canShowAction(): boolean {
      return this.visibleProductActions.includes(this.productKey);
    }
  },
  methods: {
    refresh() {
      ProductCollection.getInstance()
        .getProduct(this.productKey)
        .then(product => {
          this.product = product;
          this._refreshPriceStockInformation();
        });
    },

    _refreshPriceStockInformation() {
      if (Util.isLoggedIn() && null != this.product) {
        this.product.getPriceAndStocks().then(data => {
          this.pps = data.pps;
        });
      }
    },

    addVisibleProductAction() {
      if (this.visibleProductActions.includes(this.productKey) == false) {
        this.visibleProductActions.push(this.productKey);
      }
    },

    removeVisibleProductAction() {
      const index = this.visibleProductActions.indexOf(this.productKey);
      if (index > -1) {
        this.visibleProductActions.splice(index, 1);
      }
    }
  }
});
